import React from "react";
import PropTypes from "prop-types";

function ColumnCell(props) {

    let DisplayComponent = props.display;

    if (React.isValidElement(DisplayComponent)) {
        DisplayComponent = React.cloneElement(DisplayComponent, {...props, name: props.name, defaultValue: props.defaultValue});
    } else if(DisplayComponent === null) {
        DisplayComponent = props.children;
    } else {
        DisplayComponent = (
            <DisplayComponent {...props} name={props.name} defaultValue={props.defaultValue}>
                {props.children}
            </DisplayComponent>
        );
    }

    return (
        <td className={`${props.className} ${props.rowClass}`} align={props.alignment}>
            {DisplayComponent}
        </td>
    );
}

ColumnCell.defaultProps = {
    alignment: 'left',
    rowClass: '',
    className: '',
    display: null,
    defaultValue: null,
}

ColumnCell.propTypes = {
    name: PropTypes.string,
    display: PropTypes.any,
    defaultValue: PropTypes.any,
    className: PropTypes.string,
    alignment: PropTypes.string,
    rowClass: PropTypes.string,
}

export default ColumnCell;
